import { useAuth as useAuthCommon } from "@asantech/common/react/common/hooks/useAuth";
import { TokenFields } from "../../../../backend/src/users/types";

export const useAuth = () => useAuthCommon<TokenFields>();
